import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import addSVG from '@plone/volto/icons/add.svg';
import type { ExpandableGridData } from './schema';

const messages = defineMessages({
  addBlock: {
    id: 'Add element to column',
    defaultMessage: 'Add element to column',
  },
});

type Props = {
  data: ExpandableGridData['columns'][0];
  onAddNewBlock: () => void;
  maxLength?: number;
};

const ContainerToolbar = (props: Props) => {
  const { data, onAddNewBlock, maxLength } = props;
  const intl = useIntl();

  return (
    <div className="toolbar">
      <Button.Group>
        <Button
          aria-label={intl.formatMessage(messages.addBlock)}
          type="button"
          icon
          basic
          disabled={
            maxLength !== undefined
              ? data?.blocks_layout?.items?.length >= maxLength
              : false
          }
          onClick={() => onAddNewBlock()}
        >
          <Icon name={addSVG} size="24px" />
        </Button>
      </Button.Group>
    </div>
  );
};

export default ContainerToolbar;
